<template>
  <div class="body-notice">
    <div class='notification-item' v-for="n in dataList" :key="n.id">
      <div class="unread-tip" v-if="n.is_new">
        <icon-svg icon-class="New-Tag1"></icon-svg>
      </div>
      <div class="avatar-container">
        <UserAvatar :userInfo="n.from_user" size="40"></UserAvatar>
      </div>
      <div class="notification-content-container">
        <div v-if="n.type === notificationTypeItemLike">
          <div class="title-container">
            <span class="nickname">{{getNickName(n)}}</span> <span> 喜欢了你的动态</span>
          </div>
          <div class="description-container" @click="onClickNotification(n)">
            <div class="text-div">{{getItemAbstract(n.item)}}</div>
          </div>
        </div>
        <div v-if="n.type === notificationTypeComment">
          <div class="title-container">
            <span class="nickname">{{getNickName(n)}}</span> <span> 评论了你的动态</span>
          </div>
          <div class="description-container" @click="onClickNotification(n)">
            <div class="text-div-raw">{{getCommentText(n.comment)}}</div>
            <div class="text-div org-div">{{getItemAbstract(n.item)}}</div>
          </div>
        </div>
        <div v-if="n.type === notificationTypeReplyComment">
          <div class="title-container">
            <span class="nickname">{{getNickName(n)}}</span> <span> 对你的留言回复</span>
          </div>
          <div class="description-container" @click="onClickNotification(n)">
            <div class="text-div-raw">{{getCommentText(n.comment)}}</div>
            <div class="text-div org-div">
              {{getCommentText(n.target_comment)}}
            </div>
          </div>
        </div>
        <div v-if="n.type === notificationTypeCommentLike">
          <div class="title-container">
            <span class="nickname">{{getNickName(n)}}</span> <span> 对你的留言点赞</span>
          </div>
          <div class="description-container" @click="onClickNotification(n)">
            <div class="text-div">{{getCommentText(n.comment)}}</div>
          </div>
        </div>
        <div v-if="n.type === notificationTypeUserProfileLike">
          <div class="title-container">
            <span class="nickname">{{getNickName(n)}}</span> <span> 喜欢了你的个人主页</span>
          </div>
        </div>
        <div class="created-at">
          {{createdAt(n)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {createdAtDesc} from "../../util/common";
  import {
    ugcItemTypeImageCollection,
    ugcItemTypeMomentCraw,
    ugcItemTypeMomentUgc,
    ugcItemTypeMovie,
    ugcItemTypeNovel,
    ugcItemTypeSeries,
    ugcItemTypeUgcArticle,
    ugcItemTypeVideo
  } from "../../util/const";
  import UserAvatar from "../common/UserAvatar";

  export default {
    components: {UserAvatar},
    props: {
      dataList: {},
    },

    data() {
      return {
        notificationTypeComment: 1,
        notificationTypeCommentLike: 2,
        notificationTypeReplyComment: 3,
        notificationTypeItemLike: 4,
        notificationTypeUserProfileLike: 6,
      }
    },

    methods: {
      getNickName(notice) {
        if (!notice || !notice.from_user) {
          return ""
        }
        return notice.from_user.nickname
      },

      onClickNotification(n) {
        if (n.type === this.notificationTypeItemLike) {
          if (n.item && n.item.id) {
            this.switchRouteByItem(n.item)
          }
        } else if (n.type === this.notificationTypeComment) {
          if (n.item && n.item.id) {
            this.switchRouteByItem(n.item)
          }
        } else if (n.type === this.notificationTypeCommentLike) {
          if (n.item && n.item.id) {
            this.switchRouteByItem(n.item)
          }
        } else if (n.type === this.notificationTypeReplyComment) {
          if (n.item && n.item.id) {
            this.switchRouteByItem(n.item)
          }
        }
      },

      switchRouteByItem(item) {
        if (item.type === ugcItemTypeMomentCraw || item.type === ugcItemTypeMomentUgc) {
          this.$router.push("/moment/" + item.id)
        } else if (item.type === ugcItemTypeImageCollection) {
          this.$router.push("/collection/" + item.id)
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        } else if (item.type === ugcItemTypeNovel) {
          this.$router.push("/comment/" + item.id)  // 小说评论页
        } else if (item.type === ugcItemTypeUgcArticle) {
          this.$router.push("/article/" + item.id)
        } else if (item.type === ugcItemTypeVideo) {
          this.$router.push("/video/" + item.id)
        }
      },

      createdAt(n) {
        return createdAtDesc(n.created_at)
      },

      getItemAbstract(item) {
        if (!item) {
          return ""
        }
        let text = ""
        if (item.title) {
          text += item.title + " "
        }
        if (item.description) {
          text += item.description
        }

        if (!text) {
          text = "[图片]"
        }

        return text
      },
      getCommentText(comment) {
        if (comment && comment.content) {
          return comment.content
        } else {
          return ""
        }
      }
    }

  }
</script>

<style scoped lang="scss">

  .body-notice {
    background: white;
  }

  .notification-item {
    position: relative;
    padding: 12px 15px 8px;
    display: flex;
    border-bottom: 1px solid #f2f2f2;
  }

  .unread-tip {
    position: absolute;
    top: 0;
    right: 0;
    color:  #fc9153;
    font-size: 22px;
  }

  .avatar-container {
    margin-right: 5px;
  }

  .notification-content-container {
    margin-left: 5px;
    flex: 1 1 auto;

    .title-container {
      color: grey;

      .nickname {
        color: #333333;
      }
    }

    .description-container {
      background: rgba(242, 242, 242, 0.59);
      margin-top: 12px;
      color: rgba(42, 42, 42, 0.69);
      padding: 8px 8px;

      .text-div {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* number of lines to show */
      }

      .text-div-raw {
        padding: 5px 0;

      }

      .org-div {
        margin: 5px 0;
        color: grey;
        padding: 8px 12px;
        background: white;
      }
    }

    .created-at {
      margin-top: 12px;
      font-size: 12px;
      color: grey;
    }
  }

</style>
